import { render, staticRenderFns } from "./UpsellingCard.vue?vue&type=template&id=1732b3c3&"
import script from "./UpsellingCard.vue?vue&type=script&lang=js&"
export * from "./UpsellingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports